export const isReportableContribution = (transaction) => ['PROCESSING', 'SUCCEEDED'].includes(transaction.status || 'SUCCEEDED');

export const contributionStatusLabel = (transaction) => ({
    CREATED: 'Pending',
    PRESENTING: 'Pending',
    AUTHORIZED: 'Authorized',
    PROCESSING: 'Processing',
    SUCCEEDED: 'Completed',
    IN_REVIEW: 'In review',
    CANCELED: 'Canceled',
    RETURNED: 'Returned',
    FAILED: 'Failed',
})[transaction.status || 'SUCCEEDED'] || transaction.status;
